/*@flow*/
import type { DecksT } from './types';
import React from 'react';
import Container from './Container';
import PopupPortal from './decks/PopupPortal';
import * as I from 'immutable';

const RenderDecksComponent = (props: { map: ?Leaflet$Map, decks: DecksT }) => {
  const { map, decks } = props;
  if (!map) return null;
  if (!decks) return null;
  if (!I.Map.isMap(decks)) return null;

  return decks
    .filter((v) => (v.get ? v.get('enabled', true) : true))
    .map((v, k) => (
      <Container options={v.toJS ? v.toJS() : v} owner={map} key={k} />
    ))
    .toList()
    .push(<PopupPortal owner={map} key={999999} options={{}} />)
    .toJS();
};

export default (RenderDecksComponent: any);
